<template>
  <b-form-group
    label="Cooperado"
    :state="stateCooperado"
    :invalid-feedback="mensagemErro"
  >
    <multiselect
      label="name"
      track-by="name"
      :options="options"
      :loading="loading"
      :class="isInvalid"
      v-model="valorCooperado"
      :disabled="disableCooperado"
      selected-label="Selecionado"
      placeholder="Selecione um cooperado"
      deselect-label="Pressione Enter para remover"
      select-label="Pressione Enter para selecionar"
    >
      <span slot="noResult">Nenhum cooperado encontrado</span>
      <span slot="noOptions">Nenhum cooperado disponível</span>
    </multiselect>
  </b-form-group>
</template>

<script lang="js">
import Multiselect from "vue-multiselect";
import { CooperadoService } from "../../../../../services/astec/cooperados";

export default {
  name: "SelectCooperado",
  components: {
    Multiselect
  },
  props: {
    state: {
      type: Boolean,
      default: null
    },
    value: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      options: [],
      loading: false,
      disableCooperado: false,
      valorCooperado: this.value,
      mensagemErro: "O campo cooperado é obrigatorio."
    };
  },
  watch: {
    value(newVal) {
      this.valorCooperado = newVal;
    },
    valorCooperado(newVal) {
      this.$emit("input", newVal);
    }
  },
  computed: {
    isInvalid: function () {
      return { 'is-invalid': !this.stateCooperado };
    },
    stateCooperado() {
      if (this.state !== null) return this.state;
      return !!this.valorCooperado;
    }
  },
  async mounted() {
    await this.carregaCooperado();
  },
  methods: {
    async carregaCooperado() {
      this.loading = true;
      try {
        const dataCooperado = await CooperadoService.buscarLkpCooperado();
        this.options = dataCooperado;

        this.qtdRegistrosCooperado(dataCooperado);
      } finally {
        this.loading = false;
      }
    },

    qtdRegistrosCooperado(qtdCooperdo) {
      if (qtdCooperdo && qtdCooperdo.length <= 1) {
        this.disableCooperado = true;
      }
    }
  }
};
</script>
